import React from "react";
import { useI18n } from "@/lib/i18n";
import { Phone, EnvelopeSimple, WhatsappLogo, InstagramLogo } from "@phosphor-icons/react";

export default function Contact() {
  const { t } = useI18n();
  const items = [
    { icon: Phone, label: t("contact.phone"), value: "+62 21 555 0100" },
    { icon: EnvelopeSimple, label: t("contact.email"), value: "hello@sunkop.co" },
    { icon: WhatsappLogo, label: t("contact.wa"), value: "+62 812 3456 7890" },
    { icon: InstagramLogo, label: t("contact.social"), value: "@sunkop.id" },
  ];
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-24">
      <p className="label-eyebrow text-[hsl(var(--sk-primary))]">{t("contact.eyebrow")}</p>
      <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter">{t("contact.title")}</h1>

      <div className="mt-16 grid md:grid-cols-2 gap-16">
        <div className="grid grid-cols-2 gap-6">
          {items.map(({ icon: Icon, label, value }) => (
            <div key={label} className="p-6 bg-white rounded-2xl border border-[hsl(var(--sk-border))]" data-testid={`contact-${label.toLowerCase()}`}>
              <Icon size={28} weight="duotone" className="text-[hsl(var(--sk-primary))]" />
              <p className="mt-4 label-eyebrow text-[hsl(var(--sk-muted-fg))]">{label}</p>
              <p className="mt-2 font-mono-stat text-sm">{value}</p>
            </div>
          ))}
        </div>
        <div className="aspect-video rounded-2xl overflow-hidden bg-[hsl(var(--sk-muted))]">
          <iframe title="map" src="https://www.google.com/maps?q=Jakarta+Selatan&output=embed" className="w-full h-full border-0" />
        </div>
      </div>
    </div>
  );
}
